/// <reference path="DOMAttached.js" />

class InvitationMethod extends DOMAttached {
	constructor(el) {
		super(el);

		if (InvitationMethod.CurrentMethod == undefined) {
			InvitationMethod.CurrentMethod = this.el.closest(0).querySelector('.selected');
			if (InvitationMethod.CurrentMethod == undefined) {
				this.changeSelectedMethod(this.el);
			}
		}

		this.safeObserve(this.el, 'click', this.onInvitationMethodClick.bind(this));
	}

	onInvitationMethodClick(ev) {
		this.changeSelectedMethod(ev.currentTarget);
	}

	changeSelectedMethod(element) {
		if (element == undefined || element == InvitationMethod.CurrentMethod)
			return;
		element.classList.add('selected');
		if (InvitationMethod.CurrentMethod != undefined) {
			InvitationMethod.CurrentMethod.classList.remove('selected');
		}
		InvitationMethod.CurrentMethod = element;
	}
}
